import { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Error404 from "./pages/Error404";
import Login from "./pages/Pre_Signup/Login";
import ForgotPassword from "./pages/Pre_Signup/ForgotPassword";
import Dashboard from "./pages/Post_Signup/Dashboard";
import Settings from "./pages/Post_Signup/Settings";
import Nav from "./components/Nav";
import SidePanel from "./components/SidePanel";
import ProtectedRoute from "./components/ProtectedRoute.js";
import Queue from "./pages/Post_Signup/queue";
import UploadCard from "./pages/Post_Signup/uploadcard";
import CardBank from "./pages/Post_Signup/cardbank";
import Events from "./pages/Post_Signup/events";
import CreateCoupon from "./pages/Post_Signup/createCoupon";
import CouponsListing from "./pages/Post_Signup/couponsListing";

function App() {
  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="colored"
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <AuthenticatedApp />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function AuthenticatedApp() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen">
      <SidePanel isOpen={isSidebarOpen} onClose={handleToggleSidebar} />
      <div className="flex-1 flex flex-col overflow-y-auto">
        <Nav onToggleSidebar={handleToggleSidebar} />
        <div className="flex-1 overflow-y-auto p-4">
          <Routes>
            <Route path="home" element={<Dashboard />} />
            <Route path="queue" element={<Queue />} />
            <Route path="uploadcard" element={<UploadCard />} />
            <Route path="cards" element={<CardBank />} />
            <Route path="settings" element={<Settings />} />
            <Route path="events" element={<Events />} />
            <Route path="*" element={<Error404 />} />
              {/* Coupon Pages */}
            <Route path="coupons/create" element={<CreateCoupon />} />
            <Route path="coupons/list" element={<CouponsListing />} />

          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
